var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 12.028C21 5.93749 15.9014 6.10472 12.7542 7.11154C12.2634 7.26856 11.7366 7.26856 11.2458 7.11154C8.09863 6.10472 3 5.93749 3 12.028C3 17.377 5.77608 20.3803 7.95694 21.6951C8.79062 22.1978 9.8171 22.0077 10.7204 21.6367C11.1624 21.4551 11.6231 21.3189 12 21.3189C12.3769 21.3189 12.8376 21.4551 13.2796 21.6367C14.1829 22.0077 15.2094 22.1978 16.0431 21.6951C18.2239 20.3803 21 17.377 21 12.028Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.46967 2.21173C9.76256 1.92942 10.2374 1.92942 10.5303 2.21173C11.4371 3.08574 12.0052 4.05026 12.346 4.96259C12.9011 3.63291 14.0289 2.72289 15.3299 2.72289C15.7 2.72289 16 3.09113 16 3.54537C16 4.10888 15.9077 4.64591 15.7405 5.13492C14.3762 5.16479 13.0509 5.47092 12 5.8332C11.6768 5.72179 11.3277 5.61569 10.9595 5.52131C10.6898 4.77311 10.2283 3.96529 9.46967 3.23405C9.17678 2.95175 9.17678 2.49404 9.46967 2.21173Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.c3cac1e69be03b260213527267beefa4.svg";
export { ForwardRef as ReactComponent };